$(document).ready(function(){

    if($(window).width() < 768){
    if($(".product__media-wrapper .custom-dot").length != 0){
         setInterval(function () {
            $(".product__media-wrapper .custom-dot .dot").removeClass("active");
            $(".product__media-wrapper .custom-dot .dot:nth-child(" + $('.slider-counter--current').html() + ")").addClass("active");
        }, 100);
    }
}

  
    // if($(".product__media-wrapper .custom-dot").length != 0){
    //   setInterval(function () {
    //     console.log($('.slider-counter--current').html());
    //     $(".product__media-wrapper .custom-dot .dot").removeClass("active");
    //     $(".product__media-wrapper .custom-dot .dot:nth-child(" + $('.slider-counter--current').html() + ")").addClass("active");
    //   }, 100);
    // }

    $(".faq_section_block .faq_block_questions").click(function(){
      if($(this).parents('.faq_section_block_inner').hasClass('faq_block-active')){
        $(this).parents('.faq_section_block_inner').removeClass('faq_block-active')
        $(this).parents('.faq_section_block_inner').find('.faq_answer').slideUp();
        $(this).find('.faq_minus').addClass('hidden');
        $(this).find('.faq_plus').removeClass('hidden');
      }else{
        $('.faq_section_block_inner').removeClass('faq_block-active');
        $('.faq_section_block_inner').find('.faq_answer').slideUp();
        $('.faq_section_block_inner').find('.faq_minus').addClass('hidden');
        $('.faq_section_block_inner').find('.faq_plus').removeClass('hidden');
        $(this).parents('.faq_section_block_inner').addClass('faq_block-active')
        $(this).parents('.faq_section_block_inner').find('.faq_answer').slideDown();
        $(this).find('.faq_plus').addClass('hidden');
        $(this).find('.faq_minus').removeClass('hidden');
      }
    });

    $('.floating-wrp-btn .button--secondary').on('click', function(e) {
        setTimeout(function() {
            $('#beauty_gift_popup').removeClass("active");
        }, 500); 
    });


  // $('label[for="downshift-6-input"] + div').css('display', 'none');

  // setInterval(function () {
  //   if($(".new_downshift_input").length == 0){
  //     $("form.klaviyo-form > div > div.needsclick").each(function(){
  //       console.log($(this).find('label').text());
  //       if($(this).find("label").text() == "I am interested in"){
  //         // $(this).find("label").siblings("div").hide();
  //         $(this).find("label").parent("div").append(`<div class="custom-filed new_downshift_input">
  //             <select name="i-am-interested-in" id="new_i-am-interested-in" class="new-downshift-select" style="color: rgb(50, 50, 50); background: rgb(255, 255, 255); padding: 10px;width:100%;">
  //                 <option value="" selected disable>Select an interested</option>
  //                 <option value="Brain optimization">Brain optimization</option>
  //                 <option value="Symptom management">Symptom management</option>
  //                 <option value="Improving gut wellness">Improving gut wellness</option>
  //                 <option value="Using the system in my clinic">Using the system in my clinic</option>
  //             </select>
  //         </div>`);
  //         var ee_this = $(this);
  //         $("#new_i-am-interested-in").change(function () {
  //           console.log(ee_this.find("input"));            
  //           ee_this.find("input").val($(this).val()).trigger("change");
  //           $("#downshift-3-menu > div:nth-child(2)").trigger("click");
  //           console.log(ee_this.find("input").val());
  //         });          
  //       }
  //     });      
  //   }
  // }, 200);
  

//   setInterval(function () {
//   if ($(".new_downshift_input").length == 0) {
//     $("form.klaviyo-form > div > div.needsclick").each(function () {
//       // Check if the label with "downshift-6-input" exists
//       var label = $('label[for="downshift-6-input"]');
//       if (label.length > 0) {
//         // Create the new select dropdown element
//         var selectHTML = `
//           <div class="custom-field new_downshift_input">
//             <select name="new-select" id="new-pet-select" class="new-select" style="color: rgb(50, 50, 50); background: rgb(255, 255, 255); padding: 10px;">
//               <option value="new-option-1">New Option 1</option>
//               <option value="new-option-2">New Option 2</option>
//               <option value="new-option-3">New Option 3</option>
//             </select>
//           </div>`;

//         // Insert the new select dropdown after the label
//         label.parents('div').first().append(selectHTML);
//       }
//     });
//   }
// }, 200);


  // setInterval(function () {
  //    if ($(".new-select").length == 0) {
  //   $('label[for="downshift-6-input"] + div').hide().after(`
  //       <select name="new-select" id="new-pet-select" class="new-select" style="color: rgb(50, 50, 50); background: rgb(255, 255, 255); padding: 10px;">
  //           <option value="new-option-1">New Option 1</option>
  //           <option value="new-option-2">New Option 2</option>
  //           <option value="new-option-3">New Option 3</option>
  //       </select>`);
  //    }
  // }, 200)

   // const interval = setInterval(function () {
   //      const spanText = $('.popup-form-wrp .klaviyo-form-RXVELd form span').text().trim();
   //      if (spanText == "Thanks for subscribing!") {
   //          console.log("Popup will be hidden now.");
   //          $('#beauty_gift_popup').hide();
   //          clearInterval(interval);
   //      }
   //  }, 1000);

$(document).ready(function () {
    function getProductsToAdd() {
        let productsToAdd = [];
        productsToAdd.push({ 'id': $(".product-variant-id").val(), 'quantity': $(".quantity__input[name='quantity']").val() });
        $(".upsell-block").each(function () {
            let productId = $(this).data("id");
           // console.log('productId', productId);
            let quantity = parseInt($(this).find(".quantity_upsell_input").val(), 10);
             // console.log('quantity' , quantity); 
            if (quantity > 0) {
                productsToAdd.push({ 'id': productId, 'quantity': quantity });
            }
        });
        return productsToAdd;
    }

    function addProductsToCart(products) {
        if (products.length > 0) {
            let formData = {
             'items': products
            };
            console.log(products);
            fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
            })
            .then(response => {
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                return response.text();
            })
            .then(text => {
                try {
                    const data = JSON.parse(text);
                    // console.log('Products added successfully:', data);
                    $('.cart-notification').addClass('active');
                    let totalQuantity = products.reduce((sum, item) => sum + item.quantity, 0);
                    // console.log(totalQuantity);
                    let notificationMessage;
                    if (totalQuantity == 1) {
                        notificationtotalQuantityM;essage = 'Item added to your cart';
                    } else {
                        notificationMessage = 'Items added to your cart';
                    }
                    $('.cart-notification__heading').text(notificationMessage);
                } catch (error) {
                    console.error('Error parsing response as JSON:', text);
                }
            })
            .catch((error) => {
                console.error('Error adding products to cart:', error);
            });
        } else {
            console.log("No products to add. Please select quantities.");
        }
    }

    $(".product-clinic .product-form__submit").on("click", function (event) {
        event.preventDefault();
        let productsToAdd = getProductsToAdd();
        addProductsToCart(productsToAdd); 
    });
});


  


});